<template>
    <b-alert
      :variant="variant"
      dismissible
      fade
      :show="showDismissibleAlert"
      @dismissed="showDismissibleAlert=false"
    >
      {{message}}
    </b-alert>
</template>

<script>
export default {
    name: "FadingAlert",
    data () {
        return {
            variant: 'success',
            message: 'String',
            showDismissibleAlert: false
            }
    },
    methods: {
        hideAlert(){
            this.showDismissibleAlert = false;
            this.$store.dispatch('removeAlert');
        }
    },
    computed: {
        show_state: function (){
            return this.$store.getters['alert'].show;
        }
    },
    watch: {
        show_state(state) {
            if (state){
                this.variant = this.$store.getters['alert'].type;
                this.message = this.$store.getters['alert'].message;
                this.showDismissibleAlert = true
                setTimeout(this.hideAlert, 5000);
            }
        }
    }
}
</script>
